module.exports = {
    // '00': 'แพทย์',
    // 10: 'นักบิน',
    // 11: 'นักบิน',
    // 12: 'นักบิน',
    // 13: 'นักบิน',
    404: '-',
    14: 'ยุทธการ',
    15: 'ผู้ทำการในอากาศ',
    16: 'ผู้บังคับอากาศยานไร้คนขับ',
    17: 'ควบคุมการปฏิบัติทางอากาศ',
    18: 'ปฏิบัติการทางอวกาศ',
    24: 'นิรภัย',
    25: 'อุตุนิยมวิทยา',
    26: 'วิทยาศาสตร์',
    27: 'สารสนเทศและสงครามอิเล็กทรอนิกส์',
    28: 'ไซเบอร์',
    30: 'สื่อสารอิเล็กทรอนิกส์',
    32: 'สรรพาวุธ',
    43: 'ช่างอากาศ',
    44: 'ส่งกำลังบำรุง',
    55: 'ช่างโยธา',
    57: 'แผนที่',
    60: 'ขนส่ง',
    62: 'พลาธิการ',
    64: 'พัสดุ',
    67: 'การเงิน',
    68: 'ปลัดบัญชี',
    69: 'ตรวจสอบภายใน',
    70: 'สารบรรณ',
    71: 'ลาดตระเวนทางอากาศและภูมิสารสนเทศ',
    73: 'กำลังพล',
    74: 'สวัสดิการ',
    75: 'การศึกษาและการฝึก',
    76: 'ดุริยางค์',
    77: 'สารวัตร',
    78: 'อากาศโยธิน',
    80: 'การข่าวกรอง',
    81: 'กิจการพลเรือนและประชาสัมพันธ์',
    88: 'พระธรรมนูญ',
    89: 'อนุศาสนาจารย์',
    90: 'บริการแพทย์',
    91: 'ผู้ชำนาญการแพทย์เฉพาะอย่าง',
    92: 'เภสัชกร',
    // 93: 'แพทย์',
    // 94: 'แพทย์',
    // 95: 'แพทย์',
    97: 'พยาบาล',
    98: 'ทันตแพทย์',
    99: 'เวชศาสตร์การบิน',
    100: 'นักบิน',
    101: 'แพทย์'
};